import { Attachment } from "@PN/tabela";
import { useState } from "react";

// =================================================================
// Tipos
// =================================================================

export interface FileDescription {
  [key: string]: string;
}

// =================================================================
// Lógica de Estado
// =================================================================

export function useAnexoLogic() {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [fileDescriptions, setFileDescriptions] = useState<FileDescription>({});

  // =================================================================
  // Handlers de Arquivos
  // =================================================================

  const handleFilesSelected = (files: FileList | File[]) => {
    const fileArray = Array.from(files);
    setSelectedFiles((prev) => [...prev, ...fileArray]);

    // Inicializa descrições para novos arquivos
    const newDescriptions = { ...fileDescriptions };
    fileArray.forEach((file) => {
      if (!newDescriptions[file.name]) {
        newDescriptions[file.name] = file.name;
      }
    });
    setFileDescriptions(newDescriptions);
  };

  const handleFileDescriptionChange = (
    fileName: string,
    description: string
  ) => {
    setFileDescriptions((prev) => ({
      ...prev,
      [fileName]: description,
    }));
  };

  const clearSelectedFiles = () => {
    setSelectedFiles([]);
    setFileDescriptions({});
  };

  // =================================================================
  // Handlers de Upload
  // =================================================================

  const prepareUploadPayload = (rec: number, anexos: Attachment[]) => {
    return selectedFiles.map((file, index) => {
      const seq = String(anexos.length + index + 1);
      const description = fileDescriptions[file.name] || file.name;

      return {
        file,
        seq,
        doc: String(rec),
        description,
      };
    });
  };

  const handleUploadSuccess = () => {
    clearSelectedFiles();
    setIsPopoverOpen(false);
  };

  // =================================================================
  // Handlers de Popover
  // =================================================================

  const togglePopover = () => setIsPopoverOpen(!isPopoverOpen);

  // =================================================================
  // Retorno
  // =================================================================

  return {
    // Estado
    isPopoverOpen,
    selectedFiles,
    fileDescriptions,

    // Handlers de Arquivos
    handleFilesSelected,
    handleFileDescriptionChange,
    clearSelectedFiles,

    // Handlers de Upload
    prepareUploadPayload,
    handleUploadSuccess,

    // Handlers de Popover
    togglePopover,
  };
}
